// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdn-container {
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .cdn-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .cdn-loading {
    font-size: 18px;
    color: #555;
  }
  
  .cdn-error {
    font-size: 16px;
    color: red;
  }
  
  .cdn-input-group {
    margin-bottom: 15px;
  }
  
  .cdn-label {
    font-weight: bold;
    margin-right: 5px;
  }
  
  .cdn-input {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 300px;
  }
  
  .cdn-tags {
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
  }
  
  .cdn-tag {
    background-color: #e0e0e0;
    border-radius: 3px;
    padding: 5px 8px;
    margin: 3px;
    display: flex;
    align-items: center;
  }
  
  .cdn-tag-remove {
    background: none;
    border: none;
    color: red;
    margin-left: 5px;
    cursor: pointer;
  }
  
  .cdn-button-group {
    margin-bottom: 15px;
  }
  
  .cdn-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .cdn-button:hover {
    background-color: #0056b3;
  }
  
  .cdn-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .cdn-table-header {
    background-color: #f2f2f2;
    padding: 10px;
    text-align: left;
  }
  
  .cdn-table-row td {
    padding: 8px;
    border: 1px solid #ddd;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Admin/CdnPlatforms/cdn-platforms.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB","sourcesContent":[".cdn-container {\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .cdn-title {\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .cdn-loading {\r\n    font-size: 18px;\r\n    color: #555;\r\n  }\r\n  \r\n  .cdn-error {\r\n    font-size: 16px;\r\n    color: red;\r\n  }\r\n  \r\n  .cdn-input-group {\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .cdn-label {\r\n    font-weight: bold;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  .cdn-input {\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    width: 300px;\r\n  }\r\n  \r\n  .cdn-tags {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .cdn-tag {\r\n    background-color: #e0e0e0;\r\n    border-radius: 3px;\r\n    padding: 5px 8px;\r\n    margin: 3px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .cdn-tag-remove {\r\n    background: none;\r\n    border: none;\r\n    color: red;\r\n    margin-left: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .cdn-button-group {\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .cdn-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 12px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .cdn-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .cdn-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .cdn-table-header {\r\n    background-color: #f2f2f2;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .cdn-table-row td {\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
